import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const errorClass = css`
  color: #f64f64;
  display: block;
  text-transform: capitalize;
`;


 export const ColoredLabel = styled.span`
  color: ${({ color }) => color};
  background-color: ${({ color }) => color + "20"};
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 8px;
`;